import {ReactNode} from "react";
import "./Card.scss";

type CardProps = {
    accentColor: string;
    children: ReactNode;
}

export function Card({accentColor, children}: CardProps) {
    return (
        <div className="pg-group-card">
            <div className="pg-card-body">
                <div className="pg-card-accent" style={{backgroundColor: accentColor}}/>
                <div className="pg-card-content">
                    {children}
                </div>
            </div>
        </div>
    );
}
